import  gql  from 'graphql-tag'

export const REVOKE_SESSION = gql`mutation revokeSession($input: RevokeUserSessionInput!){
    revokeSession(input: $input){
        errors{
            field
            messages
        }
    }
}`;